<template>
  <modal @close="$emit('close')" :maxWidth="700">
    <div class="card text-left" style="width: 100%">
      <div class="card-header d-flex justify-content-between bg-transparent">
        <div v-if="editFeature">Edit Feature</div>
        <div v-else>Add New Feature</div>
        <div>
          <span style="cursor: pointer" @click="$emit('close')"
            ><i class="fa fa-times"></i
          ></span>
        </div>
      </div>
      <div class="card-body">
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label"
            >Type: {{ type == "location" ? "Location" : "Company" }}</label
          >
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Key:</label>
          <input
            type="text"
            class="form-control"
            name="key"
            v-validate="'required|regex:^[a-zA-Z0-9.-]+$'"
            v-model="feature.key"
          />
          <span class="error text-danger small" v-if="errors.has('key')">
            {{ errors.first("key") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Name:</label>
          <input
            type="text"
            class="form-control"
            name="name"
            v-validate="'required'"
            v-model="feature.name"
          />
          <span class="error text-danger small" v-if="errors.has('name')">
            {{ errors.first("name") }}
          </span>
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Heading:</label>
          <input
            type="text"
            class="form-control"
            v-model="feature.details.heading"
          />
        </div>
        <div class="mb-2">
          <label for="recipient-name" class="col-form-label">Details</label>
          <Editor
            v-validate="'required'"
            v-model="feature.details.body"
            name="body"
          />
          <span class="error text-danger small" v-if="errors.has('body')">
            {{ errors.first("body") }}
          </span>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Visible At"
              v-model="feature.visibleAt"
              v-validate="'required'"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              auto-close
              output-format="YYYY-MM-DD"
              name="visible_at"
            />
            <span
              class="error text-danger small"
              v-if="errors.has('visible_at')"
            >
              {{ errors.first("visible_at") }}
            </span>
          </div>
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Enabled At"
              v-model="feature.enabledAt"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              :disabled="type === 'location'"
              auto-close
              output-format="YYYY-MM-DD"
              name="enabled_at"
            />
          </div>
          <div class="px-1" style="width: 30%">
            <vue-ctk-date-time-picker
              label="Live At"
              v-model="feature.liveAt"
              v-validate="'required'"
              :range="false"
              color="#188bf6"
              :only-date="true"
              :noClearButton="false"
              auto-close
              output-format="YYYY-MM-DD"
              name="live_at"
            />
            <span class="error text-danger small" v-if="errors.has('live_at')">
              {{ errors.first("live_at") }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">Toggle Hidden</label>
            <select
              id="inputState"
              class="form-control"
              v-model="feature.toggleHidden"
            >
              <option :value="false" selected>No</option>
              <option :value="true">Yes</option>
            </select>
          </div>
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">Default Value</label>
            <select
              id="inputState"
              class="form-control"
              :disabled="type === 'location'"
              v-model="feature.default"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">
              Is Irreversible Feature</label
            >
            <select
              id="inputState"
              class="form-control"
              v-model="feature.isIrreversibleFeature"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
          <div class="px-1" style="width: 50%">
            <label for="inputState" class="col-form-label">
              Hide from UI (for internal testing)</label
            >
            <select
              id="inputState"
              class="form-control"
              v-model="feature.isHiddenFromUi"
            >
              <option :value="false" selected>False</option>
              <option :value="true">True</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between bg-transparent">
        <div></div>
        <div class="">
          <button class="btn btn-success" @click="save()" :disabled="saving">
            <moon-loader
              v-if="saving"
              :loading="true"
              color="white"
              size="15px"
            />
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<style scoped>
.card-body {
  max-height: 80vh;
  overflow-y: scroll;
}
</style>
<script>
import modal from "@/components/common/Modal.vue";
import Editor from "./editor.vue";
import { pick } from "lodash";
import LocationsService from "../../services/LocationsService";
export default {
  components: { modal, Editor },
  props: {
    editFeature: { type: Object, default: null },
    type: { type: String, default: "location" },
  },
  data() {
    return {
      feature: {
        type: this.type,
        key: "",
        name: "",
        details: {
          heading: "",
          body: "",
        },
        liveAt: null,
        enabledAt: null,
        visibleAt: null,
        toggleHidden: false,
        default: false,
        isIrreversibleFeature: false,
        isHiddenFromUi: false,
      },
      saving: false,
    };
  },
  created() {
    if (this.editFeature) {
      this.feature = pick(this.editFeature, [
        "key",
        "name",
        "details",
        "visibleAt",
        "liveAt",
        "enabledAt",
        "default",
        "toggleHidden",
        "isIrreversibleFeature",
        "isHiddenFromUi",
      ]);
    }
  },
  methods: {
    async save() {
      //eslint-disable-next-line
      await this.$validator.validateAll();

      //eslint-disable-next-line
      const errors = this.errors.any();

      if (errors) {
        return;
      }
      this.saving = true;
      if (this.editFeature && this.editFeature._id) {
        const feature = (
          await LocationsService.updateLabsFeature(
            this.editFeature._id,
            this.feature
          )
        ).data;
        feature._id = feature.id;
        this.$emit("updated", feature);
      } else {
        const feature = (await LocationsService.createLabsFeature(this.feature))
          .data;
        feature._id = feature.id;
        this.$emit("created", feature);
      }
      this.$emit("close");
      this.saving = true;
    },
    newFeature() {
      return {
        key: "",
        name: "",
        details: {
          heading: "",
          body: "",
        },
        liveAt: null,
        toggleHidden: false,
        isIrreversibleFeature: false,
        isHiddenFromUi: false,
      };
    },
  },
};
</script>
